import {Navbar} from "inferno-bootstrap";
import {T} from "inferno-i18next";
import {Close} from "../../components/button/Close";
import {MessageType} from "../../services/messageProvider";

export function Header(props: { minimized: boolean, onClose: (event: MouseEvent) => void }) {
	return (
		<Navbar className="navbar-dark bg-primary justify-content-between header flex-nowrap login-header">
			<div className="navbar-brand">
				<div className="navbar-brand-logo"/>
			</div>
			<div className="w-100 mb-0"/>
			<div className="d-inline-flex justify-content-end w-100">
				<Close onClose={props.onClose}/>
			</div>
		</Navbar>
	);
}
